import API from "./lib/api";

export const getAllSpendGetItemOffersApi = async (restaurant_id, query = "") => {
  try {
    const { data } = await API.get(
      `restaurant/${restaurant_id}/spend-and-get-free-item-offers?${query}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleSpendGetItemOfferApi = async (id) => {
  try {
    const { data } = await API.get(
      `restaurant/spend-and-get-free-item-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const addSpendGetItemOfferApi = async (offerData) => {
  try {
    const { data } = await API.post(
      `restaurant/spend-and-get-free-item-offers`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const editSpendGetItemOfferApi = async (offerData, id) => {
  try {
    const { data } = await API.put(
      `restaurant/spend-and-get-free-item-offers/${id}`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteSpendGetItemOfferApi = async (id) => {
  try {
    const { data } = await API.delete(
      `restaurant/spend-and-get-free-item-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleSpendGetItemOfferStatusApi = async (id) => {
  try {
    const { data } = await API.put(
      `restaurant/spend-and-get-free-item-offers/${id}/toggle-status`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
